import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import variables from 'common/styles/variables.json';
import { Avatar, Col, Modal, Row, Text, Pill, Button, Link } from 'ui';

export type Pilltype = {
  photoUrl?: string;
  name: string;
  link: string;
};

type P = {
  pills: Pilltype[];
};

const HeaderPills = ({ pills }: P) => {
  const { t } = useTranslation();

  const [isModalWithMoreCommunitiesOpened, setIsModalWithMoreCommunitiesOpened] = useState(false);

  if (pills.length === 0) {
    return null;
  }

  const handleClose = () => {
    setIsModalWithMoreCommunitiesOpened(false);
  };

  const firstPill = pills[0];

  return (
    <div className="content-header-pills">
      <Link to={firstPill.link} className="content-header-pills__link">
        <Pill title={firstPill.name} />
      </Link>

      {pills.length > 1 ? (
        <>
          <Button onClick={() => setIsModalWithMoreCommunitiesOpened(true)} type="link" size="large">
            <Pill title={t('morePills', { pillsNumber: pills.length - 1 })} />
          </Button>
          <Modal
            title={t('More communities')}
            disableBack
            isOpened={isModalWithMoreCommunitiesOpened}
            onCancel={handleClose}
            width="small"
          >
            <Row item={{ gutter: [0, variables.spaceMd.value] }}>
              {pills.map((pill) => (
                <Col item={{ span: 24 }}>
                  <Link to={pill.link}>
                    <Row
                      item={{
                        align: 'middle',
                        gutter: [variables.spaceMd.value, 0],
                      }}
                    >
                      {pill.photoUrl ? (
                        <Col>
                          <Avatar photo={pill.photoUrl} />
                        </Col>
                      ) : null}
                      <Col item={{ flex: 1 }}>
                        <Text>{pill.name}</Text>
                      </Col>
                    </Row>
                  </Link>
                </Col>
              ))}
            </Row>
          </Modal>
        </>
      ) : null}
    </div>
  );
};

export default HeaderPills;
